<template>
    <div>
        <buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps"  ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <el-table
                        id="xpane-1"
                        :data="dataSet_sal"
                        ref="singleTable"
                        v-loading="loadingbase"
                        :highlight-current-row="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        :row-class-name="tableRowClassName"
                        header-row-class-name="headerclass"
                        row-key="uniquenumber"
                        lazy
                        @row-click="edits"
                        style="width: 100%; margin-top:5px"
                >
                    <el-table-column show-overflow-tooltip width="90px;" prop="shiporderno" :label="$t('getapi[2292]')"></el-table-column>
                    <el-table-column show-overflow-tooltip width="80px;" prop="trans_time" :label="$t('getapi[2313]')"></el-table-column>
                    <el-table-column show-overflow-tooltip width="60px;" prop="operation_person" :label="$t('getapi[2289]')"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120px;" prop="part_code" :label="$t('getapi[112]')"></el-table-column>                   
                    <el-table-column show-overflow-tooltip width="40px;" prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                    <el-table-column show-overflow-tooltip width="90px;" prop="poorderno" :label="$t('getapi[2291]')"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px;" prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <el-table
                        id="xpane-0"
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        :row-class-name="tableRowClassName"
                        header-row-class-name="headerclass"
                        row-key="uniquenumber"
                        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                        lazy
                        :load="load"
                        style="width: 100%; margin-top:5px"
                >
                
                    <el-table-column show-overflow-tooltip prop="uniquenumber" label="" width="80">
                        <template>
                            <i class="el-icon-tickets"></i>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ilevel" :label="$t('getapi[8148]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="schedule_no" :label="$t('getapi[4209]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="routing_road" :label="$t('getapi[8388]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="sonequencenodesc" :label="$t('getapi[8233]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="parttype" :label="$t('getapi[6117]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="sostatus" :label="$t('getapi[6356]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[1479]')"></el-table-column>
                    <el-table-column prop="actual_finish_qty" :label="$t('getapi[6359]')" align="right">
                        <template slot-scope="scope">
                            {{scope.row.actual_finish_qty | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="total_issue_qty" :label="$t('getapi[2874]')" align="right">
                        <template slot-scope="scope">
                            {{scope.row.total_issue_qty | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="to_inv_qty" :label="$t('getapi[4219]')" align="right">
                        <template slot-scope="scope">
                            {{scope.row.to_inv_qty | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="scrap_qty" :label="$t('getapi[4220]')" align="right">
                        <template slot-scope="scope">
                            {{scope.row.scrap_qty | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="finished_product_receive" :label="$t('getapi[6358]')" align="right">
                        <template slot-scope="scope">
                            {{scope.row.finished_product_receive | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_master_unit" :label="$t('getapi[888]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="datestr" :label="$t('getapi[4215]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="coll_orderno" :label="$t('getapi[463]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
                </el-table>
            </li>
        </ul> 

        <serce :isVisible="isVisible" queryData="ProSOlayerManagement" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'saleslevparttrac',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [],
                dataSet_sal: [],
                loading: '',
                loadingbase: '',
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                selectData: [],
                scrollTop:0,
                iscontinuedblclick: true,
                code:'',
                timeId: null,
                part_code: '',
                part_version: '',
                so_code: '',
            };
        },
        
        create() {
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            // this.btnauthority();
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this
            this.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                let height = res.target
                this.scrollTop = height.scrollTop
            },false)
            that.$limits.dragControllerDiv1();
            that.authority();
        },
        activated () {   // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 20)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4004]") + '新',this.$t("getapi[25]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            },
            //拖动条中间快捷按钮
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left1');
                let mid = document.getElementsByClassName('mid1');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left1');
                let mid = document.getElementsByClassName('mid1');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'saleslevparttrac');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            getView() {
                let that = this;
                that.loadingbase = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac
                };
                that.$http.urlpost('/Sal/Order/GetSalShipNoteRelateSoList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet_sal = res.DataContent;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loadingbase = false;
                });
            },
            LoadSoView(part_code,part_version,so_code) {
                let that = this;
                that.loading = true;
                that.part_code=part_code
                that.part_version=part_version
                that.so_code=so_code;
                let data = {
                    part_code: that.part_code,
                    part_version: that.part_version,
                    so_code: that.so_code
                };
                that.$http.urlpost('/Sal/Order/GetSalShipNoteBySOLayerManagerList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.List;
                        for(let i =0;i<that.dataSet.length;i++){
                            that.dataSet[i].hasChildren = true
                        }
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });

                clearTimeout(that.timeId);
            },
            exps(){
                let that = this;
                let data = {
                    part_code: that.part_code,
                    part_version: that.part_version,
                    so_code: that.so_code
                };
                that.$http.urlpost('/Sal/Order/GetSalShipNoteBySOLayerToExecl', data, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
            },
            
            // 获取子数据
            getSonView(row){
                let that = this
                
                if(row.hasChildren == false){
                    return
                }
                let parm = {
                    so_code: row.so_code,
                    schedule_no: row.schedule_no,
                    plan_finish_qty: row.plan_finish_qty,
                    part_code: row.part_code,
                    part_version: row.part_version,
                    ilevel: row.ilevel,
                    uniquenumber: row.uniquenumber,
                    expand:row.expand,
                    parttype:row.parttype,
                }
                that.token = JSON.parse(that.userData).token;
                $.ajax({
                    url: Common.Url + '/Sal/Order/GetSalShipNoteBySOLayerManagerChildren?token=' + that.token,
                    type: 'post',
                    async: false,
                    data: JSON.stringify(parm),
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            let data1 = res.DataContent.List
                            if(data1.length != 0){
                                for(let i = 0;i<data1.length;i++){
                                    data1[i].hasChildren = true
                                }
                                row.children = data1
                            } else {
                                row.hasChildren = true
                                row.children = []
                            }
                        } 
                    },
                    error: function (xhr, errorType, error) {
                        
                    }
                });
                
            },
            edits(jsd) {
                let that = this;
                
                // if(that.code == jsd.so_code){
                //     return
                // }
                that.timeId = setTimeout(() => {                    
                    that.iscontinuedblclick = true
                    that.code = jsd.so_code
                    that.LoadSoView(jsd.part_code,jsd.part_version,jsd.so_code);
                }, 100);
            },
            load(row, treeNode, resolve) {
                let that = this
                that.getSonView(row)
                setTimeout(() => {
                    resolve(
                        row.children
                    )
                }, 1000)                
            },
            tableRowClassName({row, rowIndex}) {
                console.log(row)
               
                if(row.color == 1){
                    return 'blue'
                }
                if(row.color == 2){
                    return 'red'
                }
                if(row.color == 3){
                    return 'gray'
                }
                if(row.color == 4){
                    return 'black'
                }
                if(row.bgcolor == 1){
                    return 'aliceblue'
                }

            },
        }
    };
</script>

<style  scoped lang="less">
    span.label-fade-enter {
        font-size: medium;
        margin-right: 20px;
    }
    /deep/.blue{
        color: blue;
    }
    /deep/.red{
        color: red;
    }
    /deep/.gray{
        color: #805043;
    }
    /deep/.black{
        color: black
    }
    /deep/.aliceblue{
        background: #c0fff3;
    }
    /deep/.grayb{
        background: #d9d6d5;
    }
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-dropdown {
        vertical-align: top;
        background-color: #ffd04b !important;
        border-color: #ffd04b !important;
        color: #ffffff;
        margin-left: 20px;
        padding: 0 14px;
        border-radius: 5px;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto;
            white-space: pre;
            span {
                margin-left: 10px;
                margin-right: 5px;
                width: 70px;
                text-align: right;
                line-height: 35px;
                display: inline-block;
            }
        }
    }

    span.titles {
        margin-left: 14px;
        margin-right: 15px;
        text-align: left;
        line-height: 40px;
        display: inline-block;
    }
    .box .bbl span{
        line-height: 28px;
    }
</style>
 
